import script from "./PropositionReservation.vue?vue&type=script&setup=true&lang=js"
export * from "./PropositionReservation.vue?vue&type=script&setup=true&lang=js"

import "./PropositionReservation.vue?vue&type=style&index=0&id=2c532dbe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c532dbe"]])

export default __exports__